import { TenantType } from '../../enums'
import { Settings } from '../../models'
import { DEFAULT_INFO, DEFAULT_TENANT_SETTINGS } from '../tenant'

export const DEFAULT_SETTINGS: Settings = {
  user: {
    id: '',
    firstName: '',
    lastName: '',
    mail: '',
    defaultTenant: '',
    tenants: [],
  },
  tenant: {
    id: '',
    name: '',
    info: DEFAULT_INFO(''),
    type: TenantType.FOOD,
    settings: DEFAULT_TENANT_SETTINGS,
    features: [],
    theme: [],
    rooms: [],
    shifts: [],
    services: [],
    employees: [],
    categories: [],
  },
}
